import React, { useEffect } from "react";
import WxContentsDispatcher from "./WxContentsDispatcher";
import { lastUpdateState, useAirportGroupList } from "../../../store/AirportGroupState";
import { Loading } from "../../../parts/Loading";
import { useRecoilValue } from "recoil";
import { useFlightPlan } from "../../../store/FlightPlanState";

const MetarTafDispatcherInner = (props) => {
  const { airportGroupList } = useAirportGroupList();
  const lastUpdate = useRecoilValue(lastUpdateState);
  const { editState } = useFlightPlan();

  useEffect(()=>{
    props.contents.setAirportGroupList(airportGroupList);
  }, [airportGroupList, props.contents]);

  useEffect(()=>{
    props.contents.reflectChangeAirportGroup(lastUpdate);
  }, [lastUpdate, props.contents]);

  useEffect(() => {
    props.contents.setRespondable(!editState.editing);
  }, [editState, props.contents]);

  return <WxContentsDispatcher {...props}/>
};

const MetarTafDispatcher = (props) => {

  return (
    <>
      <React.Suspense fallback={<Loading/>}>
        <MetarTafDispatcherInner {...props}/>
      </React.Suspense>
    </>
  );
};

export default MetarTafDispatcher;